import { render } from "./GeneralDetailsPanel.vue?vue&type=template&id=4241d4e2"
import script from "./GeneralDetailsPanel.vue?vue&type=script&lang=js"
export * from "./GeneralDetailsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__